import React from 'react';
import { products, categories } from '../mock';
import SiteHeader from './SiteHeader';
import Hero from './Hero';
import ProductCard from './ProductCard';
import AboutContact from './AboutContact';

const CategoryPage = ({ category, onOpenProduct }) => {
  const meta = categories[category];
  const items = products.filter((p) => p.category === category);
  const featured = items.find((p) => p.featured);

  return (
    <>
      <SiteHeader onOpenProduct={onOpenProduct} />

      {featured && <Hero product={featured} onOpenProduct={onOpenProduct} />}

      <section
        className={`q-section ${category === 'gorras' ? 'q-section--alt' : ''}`}
        data-testid={`${category}-section`}
      >
        <div className="q-section__inner">
          <div className="q-section__head">
            <span className="q-section__eyebrow">{meta.eyebrow}</span>
            <h2 className="q-section__title">{meta.title}</h2>
            <p className="q-section__sub">{meta.sub}</p>
          </div>

          {items.length > 0 && (
            <div className="q-trust-strip" data-testid="trust-strip">
              <span>
                {['joyeria', 'van-cleef', 'conjuntos'].includes(category)
                  ? 'Laminado en oro 18k'
                  : 'Ediciones premium seleccionadas'}
              </span>
              <span className="q-trust-strip__dot" aria-hidden="true" />
              <span>Atención directa por WhatsApp</span>
            </div>
          )}

          {items.length === 0 ? (
            <div className="q-empty" data-testid="category-empty-state">
              <p className="q-empty__title">Próximamente</p>
              <p className="q-empty__text">
                Estamos preparando esta colección. Muy pronto disponible.
              </p>
            </div>
          ) : (
            <div className={`q-grid q-grid--${category}`}>
              {items.map((p, i) => (
                <ProductCard
                  key={p.id}
                  product={p}
                  large={category === 'joyeria' && i === 0}
                  onOpen={onOpenProduct}
                  autoRotate
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <AboutContact />
    </>
  );
};

export default CategoryPage;
